import React, { useMemo } from 'react';
import { CheckboxField } from '../../../../ui-toolkit';
import { SimpleGrid } from '../../../../tailwindComponents/grid/SimpleGrid';
import { SelectFieldTW } from '../../../../tailwindComponents/selectTW/SelectFieldTW';
import { useListFeaturesQuery } from '../../../../API/administration/FeaturesAPI';
import { useHasPermissions } from '../../../accessControl/hooks/useHasPermissions';
import { ePermissions } from '../../../../types/administration/userAdministration/ePermissions';
import { SelectOption } from '../../../../tailwindComponents/selectTW/interfaces';
import { useListAdminUserRolesQuery } from '../../../../API/administration/AdminUsersAPI';

export const FeatureRoleFormFields: React.FC = () => {
  const hasReadPermission = useHasPermissions([ePermissions.FeatureRead]);
  const { data: sortedGlobalFeatures = [] } = useListFeaturesQuery(undefined, { skip: !hasReadPermission });
  const { data: roles = [] } = useListAdminUserRolesQuery(undefined);

  const featureOptions: SelectOption[] = useMemo(
    () =>
      sortedGlobalFeatures
        .filter((feature) => feature.isEditable) // Only show editable features
        .map((feature) => ({
          label: feature.name,
          value: feature.name,
        })),
    [sortedGlobalFeatures]
  );

  const roleOptions: SelectOption[] = useMemo(
    () =>
      roles.map(({ label, id }) => ({
        label,
        value: id,
      })),
    [roles]
  );

  return (
    <SimpleGrid>
      <SelectFieldTW name={'name'} labelText={'Feature'} options={featureOptions} />
      <SelectFieldTW name={'roleId'} options={roleOptions} labelText={'Role'} />
      <CheckboxField name={'isOn'} text={'Activate'} />
    </SimpleGrid>
  );
};
